import { Badge, Typography } from '@qodo/design-system';
import { usePricingConfig, type PlanSku } from 'hooks/billing/usePricingConfig';
import { spawn } from 'utils/translations';
import {
  estimateEngineersCount,
  estimateReviewsCount,
} from '../../ConversionPopup/utils';

const spawnPopup = spawn('billing.popup');

interface RecommendedPlanCardProps {
  plan: PlanSku;
}

export const RecommendedPlanCard = ({ plan }: RecommendedPlanCardProps) => {
  const cfg = usePricingConfig();
  const reviews = estimateReviewsCount(plan.credits, cfg);
  const engineers = estimateEngineersCount(plan.credits, cfg);

  return (
    <div className="relative min-w-86.75 shrink-0 rounded-lg border border-border-interactive-emphasis-active bg-fill-interactive-emphasis-idle px-6 py-4">
      <Badge className="absolute -top-2 left-2 bg-fill-panel-neutral!">
        {spawnPopup('sku.recommended')}
      </Badge>
      <div className="flex items-start justify-between gap-2">
        <div className="flex flex-col gap-3">
          <div>
            <Typography
              variant="h2"
              as="p"
              className="text-[29px] leading-[120%] tracking-normal text-text-general-neutral-strongest"
            >
              {spawnPopup('price-monthly', {
                price: String(plan.priceMonthly),
              })}
            </Typography>
            <Typography variant="s" className="text-text-general-neutral-mid">
              {spawnPopup('sku.designed-for', { count: String(engineers) })}
            </Typography>
          </div>
          <div className="flex flex-col gap-1">
            <Typography
              variant="h4"
              as="p"
              className="leading-[120%] tracking-normal text-text-general-neutral-strongest"
            >
              {spawnPopup('sku.reviews-full', { count: String(reviews) })}
            </Typography>
            <Typography variant="s" className="text-text-general-neutral-mid">
              {spawnPopup('sku.credits', {
                credits: plan.credits.toLocaleString(),
              })}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};
